import { defineComponent as t } from "vue";
import "./FadingCircle.css";
let o = 0;
const d = t({
  name: "FadingCircle",
  props: {
    size: { type: Number, default: 0 },
    color: { type: String, default: "" }
  },
  data() {
    return {
      styleNode: {},
      id: 0
    };
  },
  computed: {
    spinnerColor() {
      return this.color || "#ccc";
    },
    spinnerSize() {
      return (this.size || 28) + "px";
    }
  },
  beforeCreate() {
    this.id = ++o;
  },
  created() {
    this.styleNode = document.createElement("style");
    const e = `.circle-color-${this.id} > div::before { background-color: ${this.spinnerColor}; }`;
    this.styleNode.lang = "text/css", this.styleNode.title = "fading circle style", document.getElementsByTagName("head")[0].appendChild(this.styleNode), this.styleNode.appendChild(document.createTextNode(e));
  },
  unmounted() {
    this.styleNode && this.styleNode.parentNode && this.styleNode.parentNode.removeChild(this.styleNode);
  }
});
export {
  d as default
};
